<form (ngSubmit)="submit()" [formGroup]="formGroup" class="form-container">
	<div class="field-container">
		<div class="row">
			<!-- Component Name -->
			<mat-form-field appearance="outline" class="form-field">
				<mat-label>{{ 'name' | translate }}</mat-label>
				<input formControlName="name" matInput required name="name" />
				@if (formGroup.get('name')?.invalid) {
					<mat-error>{{ 'please_enter_valid_value' | translate }}</mat-error>
				}
			</mat-form-field>

			<!-- Value -->
			<mat-form-field appearance="outline" class="form-field">
				<mat-label>{{ 'value' | translate }}</mat-label>
				<input formControlName="value" matInput />
			</mat-form-field>

			<!-- Unit -->
			<mat-form-field appearance="outline" class="form-field">
				<mat-label>{{ 'unit' | translate }}</mat-label>
				<input formControlName="unit" matInput />
				@if (formGroup.get('unit')?.invalid) {
					<mat-error>{{ 'please_enter_valid_value' | translate }}</mat-error>
				}
			</mat-form-field>
		</div>
		<div class="row">
			<!-- Description -->
			<mat-form-field appearance="outline" class="form-field">
				<mat-label>{{ 'description' | translate }}</mat-label>
				<input formControlName="description" matInput />
				@if (formGroup.get('description')?.invalid) {
					<mat-error>{{ 'please_enter_valid_value' | translate }}</mat-error>
				}
			</mat-form-field>
		</div>
	</div>
	<!-- Buttons -->
	<div class="buttons-container">
		<button
			[disabled]="formGroup.invalid"
			(click)="submit()"
			[attr.aria-label]="'submit' | translate"
			mat-icon-button
			type="submit"
		>
			<mat-icon>check</mat-icon>
		</button>
		<button
			(click)="cancelSubmit()"
			[attr.aria-label]="'close' | translate"
			mat-icon-button
			type="button"
		>
			<mat-icon>close</mat-icon>
		</button>
	</div>
</form>
